import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @description Contains functions to select the mode when using a progressive format.
 * <b>Learn more</b>: {@link https://cloudinary.com/documentation/transformation_reference#fl_progressive|Progressive modes}
 * @memberOf Qualifiers
 * @namespace Progressive
 * @example
 * import {Cloudinary} from "@cloudinary/url-gen";
 * import {format} from "@cloudinary/url-gen/actions/delivery";
 * import {jpg} from "@cloudinary/url-gen/qualifiers/format";
 * import {steep} from "@cloudinary/url-gen/qualifiers/progressive";
 *
 * const yourCldInstance = new Cloudinary({cloud: {cloudName: 'demo'}});
 * const image = yourCldInstance.image('woman');
 * image.delivery(format(jpg()).progressive(steep()))
 */
import { FlagQualifier } from "./flag/FlagQualifier.js";

var ProgressiveQualifier = /*#__PURE__*/function (_FlagQualifier) {
  _inherits(ProgressiveQualifier, _FlagQualifier);

  var _super = _createSuper(ProgressiveQualifier);

  function ProgressiveQualifier(mode) {
    _classCallCheck(this, ProgressiveQualifier);

    return _super.call(this, 'progressive', mode);
  }

  return ProgressiveQualifier;
}(FlagQualifier);
/**
 * @memberOf Qualifiers.Progressive
 */


function none() {
  return new ProgressiveQualifier('none');
}
/**
 * @memberOf Qualifiers.Progressive
 */


function semi() {
  return new ProgressiveQualifier('semi');
}
/**
 * @memberOf Qualifiers.Progressive
 */


function steep() {
  return new ProgressiveQualifier('steep');
}
/**
 * @memberOf Qualifiers.Progressive
 */


function progressive() {
  return new ProgressiveQualifier();
}

var Progressive = {
  semi: semi,
  none: none,
  steep: steep,
  progressive: progressive,
  ProgressiveQualifier: ProgressiveQualifier
};
export { Progressive, semi, none, steep, progressive, ProgressiveQualifier };